import wixWindow from 'wix-window';

let formFactor = wixWindow.formFactor;

//

$w.onReady(function () {

    if (formFactor !== "Mobile") {
        $w("#htmlMap").src = "https://www.wix.com/wix-platform/map-payments?en"
    } else {
        $w("#htmlMapMobile").src = "https://www.wix.com/wix-platform/map-payments/home-mobile?en"

    }

});